<template>
  <div class="adminAlarm alarmSNew">
    <div class="section" style="box-shadow: none">
      <!-- <div class="alarmname">{{$t('alarm.Alarm_List')}}</div> -->
      <div class="search">
        <div class="left">
          <span class="search-label">{{ $t("alarm.Alarm_Type") }}</span>
          <el-select
            v-model="search.level"
            :placeholder="$t('header.pleaseSelect')"
            size="small"
            clearable
            @change="getData(true)"
            popper-class="select-search-recharge"
            class="selectClearNew"
          >
            <el-option
              v-for="item in level"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span class="select-label">{{ item.label }}</span>
            </el-option>
          </el-select>
          <span class="search-label">{{ $t("alarm.Alarm_Status") }}</span>
          <el-select
            v-model="search.handle"
            size="small"
            clearable
            @change="getData(true)"
            popper-class="select-search-recharge"
            class="selectClearNew"
          >
            <el-option
              v-for="item in handle"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span class="select-label">{{ item.label }}</span>
            </el-option>
          </el-select>
          <el-date-picker
            :editable="false"
            @change="getData(true)"
            clearable
            v-model="datevalue"
            type="daterange"
            align="left"
            unlink-panels
            ref="datePickerRange"
            :range-separator="$t('report.to')"
            :default-value="new Date().setMonth(new Date().getMonth() - 1)"
            :picker-options="pickerrangeOptions"
            :start-placeholder="$t('report.start_date')"
            :end-placeholder="$t('report.End_date')"
            popper-class="select-date1"
          >
          </el-date-picker>
        </div>
        <div class="right">
          <el-button class="button button-solid" @click.stop="showSearchBtn">
            <i class="el-icon-search"></i>
          </el-button>
          <el-tooltip
            :content="$t('alarm.archiveTip')"
            placement="top"
            effect="dark"
          >
              <i class="el-icon-warning" style="font-size: 20px;margin: 0 14px;color: #ec9630;"></i>
          </el-tooltip>
          <el-button
            type="text"
            class="button-export"
            :disabled="exportReportMonthLoad"
            @click="exportReportMonth()"
            >{{ $t("report.Export_alarm") }}</el-button
          >
          <el-button
            type="text"
            class="button-export"
            :disabled="exportReportMonthLoad"
            @click="queryExportList(2)"
            >{{ $t("alarmNew.history") }}</el-button
          >
          <el-button
            type="text"
            class="button-export"
            @click="goToArchiveHistory"
            >{{ $t("alarm.archiveRecord") }}</el-button
          >
          <div class="search-alert" v-if="showSearch">
            <div class="searchDiv">
              <el-input
                class="searchAll"
                ref="iptFocus"
                v-model.trim="search.search"
                @keyup.enter.native="getData(true)"
                placeholder="PN"
                clearable
              >
                    <!-- <el-select popper-class="select-search-recharge" v-model="search.select" slot="prepend"   :placeholder="this.$t('header.pleaseSelect')">
                         <el-option label="PN" value="PN"></el-option>
                         <el-option label="SN" value="SN"></el-option>
                   </el-select> -->
                <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
              </el-input>
              <!-- 搜索 -->
              <span class="search-device" @click="getData(true)">{{
                $t("recharge.Search")
              }}</span>
              <!-- 取消 -->
              <span class="search-hide" @click="closeSearch">{{
                $t("rate.cancel")
              }}</span>
            </div>
          </div>
        </div>

        <!-- 批量操作弹条 (显隐由是否勾选决定) -->
        <div class="batch-alert" v-show="selectedAlarm.length">
          <!-- 当前选中条数 -->
          <span class="batch-total">
            {{
              `${$t("alarm.curSelected")} ${selectedAlarm.length} ${$t(
                "alarm._Data"
              )}`
            }}
          </span>
          <div class="batch-right">
            <!-- 操作 -->
            <span class="batch-operate">
              <!-- 删除 -->
              <span class="btn" @click="detelealarm(selectedAlarm)">
                {{ $t("device.delete") }}
                <i class="ico ico-clear"></i>
              </span>
            </span>
            <!-- 取消 -->
            <span class="batch-hide" @click="closeBatch">{{
              $t("rate.cancel")
            }}</span>
          </div>
        </div>
      </div>

      <el-table
        :data="alarmlist"
        border
        stripe
        height="100%"
        :row-style="{ height: 0 }"
        :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        v-loading="alarmloading"
        element-loading-spinner="el-icon-loading"
        @selection-change="changeFun"
        class="tablemain tableloding"
        :empty-text="$t('account.nodata')"
        ref="multipleSnTable"
        :cell-class-name="addClass"
      >
        <el-table-column type="selection" fixed></el-table-column>
        <el-table-column
          prop="gts"
          fixed
          min-width="180px;"
          :label="$t('alarm.Occurrence_time')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="level"
          min-width="145px;"
          :label="$t('alarm.Alarm_Type')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div
              :class="`background-${level[scope.row.level].name}`"
              style="border-radius: 5px; margin: 0 20px"
            >
              <span
                :class="`radius-${level[scope.row.level].name}`"
                style="
                  width: 8px;
                  height: 8px;
                  border-radius: 8px;
                  display: inline-block;
                  margin-right: 5px;
                "
              ></span>
              <span
                v-if="scope.row.level !== undefined"
                :class="`color-${level[scope.row.level].name}`"
                >{{ level[scope.row.level].label }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="110px"
          prop="handle"
          :label="$t('alarm.Alarm_Status')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.handle.class == 'untreated'"
              style="color: #ec9630"
              >{{ scope.row.handle.label }}</span
            >
            <span v-else style="color: rgba(255, 255, 255, 0.3)">{{
              scope.row.handle.label
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100px;"
          :label="$t('alarm.Alarm_Code')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :title="scope.row.code || '--'">{{
              scope.row.code || "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="desc"
          min-width="130px;"
          :label="$t('alarm.Alarm_Describe')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="sn"
          min-width="150px;"
          :label="$t('alarm.Device_SN')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              class="redirect"
              @click="enterDevice(scope.row)"
              :title="scope.row.deviceSn||scope.row.sn || '--'"
              >{{ scope.row.deviceSn || scope.row.sn || "--" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="pn"
          min-width="130px;"
          :label="$t('alarm.Device_PN')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="devaddr"
          min-width="85px;"
          :label="$t('alarm.device_address')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('alarm.Operation')"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              :title="$t('alarm.details')"
              @click="checkalarm(scope.row)"
            >
              <i class="iconfont icon-a-mingchenggaojingrizhi2"></i>
            </el-button>
            <el-button
              type="text"
              class="operation"
              :title="$t('alarm.deletes')"
              @click="detelealarm([scope.row])"
            >
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="tablebottom">
        <!-- 占个坑位，不然分页会掉出来屏幕之下 -->
        <!-- <div v-else class="pagination"></div> -->
        <!-- 批量删除 -->
        <!-- <button
          style="height:32px;margin-left:16px;"
          class="btn"
          :class="selectedAlarm.length ? 'btn-dark' : 'btn-disable'"
          @click="detelealarm(selectedAlarm)"
        >{{$t('alarm.Delete_selected')}}</button> -->
        <!-- 批量占位 -->
        <span class="" style="margin-left: 16px"></span>
        <!-- 分页 -->
        <el-pagination
          class="pagination"
          background
          @size-change="getData(true)"
          @current-change="() => getData()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color: #ffffff; padding-left: 15px"
            >{{ $t("device.pageSize") }} :</span
          >
        </el-pagination>
      </div>
    </div>
    <!-- 告警详情 -->
    <deletesalarm-dialog
      :title="$t('alarm.alarmDetails')"
      :width="
        this.$lang.currentLang == 'zh_CN' ||
        this.$lang.currentLang == 'en_US' ||
        this.$lang.currentLang == 'en_ID'
          ? '460px'
          : '560px'
      "
      :class="{
        showDialog: showcheckalarmdialog,
        hideDialog: !showcheckalarmdialog,
      }"
      :visible.sync="showcheckalarmdialog"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="checkalarm">
          <div class="alarmdetails" style="color: #30d096; font-size: 16px">
            {{ $t("alarm.alarmInfo") }}
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Occurrence_time") }}</span>
            <span>{{ checkData.gts }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.endtime") }}</span>
            <span>{{ checkData.cts || "--" }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Alarm_Status") }}</span>
            <span
              v-if="checkData.handle.class == 'untreated'"
              style="color: #ec9630"
              >{{ checkData.handle.label }}</span
            >
            <span v-else style="color: rgba(255, 255, 255, 0.3)">{{
              checkData.handle.label
            }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Alarm_Type") }}</span>
            <div
              :class="`background-${level[checkData.level].name}`"
              style="border-radius: 5px; padding: 0 10px"
            >
              <span
                :class="`radius-${level[checkData.level].name}`"
                style="
                  width: 8px;
                  height: 8px;
                  border-radius: 8px;
                  display: inline-block;
                  margin-right: 5px;
                "
              ></span>
              <span
                v-if="checkData.level !== undefined"
                :class="`color-${level[checkData.level].name}`"
                >{{ level[checkData.level].label }}</span
              >
              <span v-else>{{ "--" }}</span>
            </div>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Alarm_Code") }}</span>
            <span>{{ checkData.code }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Alarm_Describe") }}</span>
            <span>
              <el-tooltip
                :content="checkData.desc"
                placement="top"
                effect="dark"
              >
                <span class="ellipsis-span">
                  {{ checkData.desc }}
                </span>
              </el-tooltip>
            </span>
          </div>
        </div>
        <div class="checkalarm">
          <div class="alarmdetails" style="color: #30d096; font-size: 16px">
            {{ $t("alarm.alarmDevice") }}
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Device_Type") }}</span>
            <span>
              <span>{{
                brand[checkData.brand == fieldUndefined ? 10 : checkData.brand]
                  .label
              }}</span>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Device_SN") }}</span>
            <!-- <span>{{ checkData.sn }}<i @click="copy(checkData.sn)" style="color:#33FFB6;padding-left:10px;" class="iconfont icon-biaogegongneng_fuzhi"></i></span> -->
            <span>
              <el-tooltip :content="checkData.deviceSn || checkData.sn" placement="top" effect="dark">
                <span class="ellipsis-span">
                  {{ checkData.deviceSn || checkData.sn }}
                </span>
              </el-tooltip>
              <i
                @click="copy(checkData.deviceSn || checkData.sn)"
                style="color: #33ffb6; padding-left: 10px"
                class="iconfont icon-biaogegongneng_fuzhi"
              ></i>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.device_alias") }}</span>
            <span>
              <el-tooltip
                :content="checkData.alias || checkData.sn"
                placement="top"
                effect="dark"
              >
                <span class="ellipsis-span">
                  {{ checkData.alias || checkData.sn || "--" }}
                </span>
              </el-tooltip>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.device_address") }}</span>
            <span>{{ checkData.devaddr }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.Device_PN") }}</span>
            <span
              >{{ checkData.pn
              }}<i
                @click="copy(checkData.pn)"
                style="color: #33ffb6; padding-left: 10px"
                class="iconfont icon-biaogegongneng_fuzhi"
              ></i
            ></span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t("alarm.User") }}</span>
            <span>
              <el-tooltip
                :content="checkData.usr"
                placement="top"
                effect="dark"
              >
                <span
                  style="color: #30d096; cursor: pointer"
                  @click="enterDevice(checkData)"
                  class="ellipsis-span"
                >
                  {{ checkData.usr }}
                </span>
              </el-tooltip>
            </span>
          </div>
        </div>
        <div class="deletfotter" style="text-align: center; margin-top: 28px">
          <button class="btn btn-light" @click="showcheckalarmdialog = false">
            {{ $t("alarm.Close") }}
          </button>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警 去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="showdeletesalarmdialog" -->
    <deletesalarm-dialog
      :title="$t('alarm.deletes')"
      :class="{
        showDialog: showdeletesalarmdialog,
        hideDialog: !showdeletesalarmdialog,
      }"
      :visible.sync="showdeletesalarmdialog"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width: 100%; text-align: left">{{
            $t("alarm.delete_alarm")
          }}</span>
        </div>
        <div class="disabledescr">
          <span style="width: 100%; text-align: left; margin-top: 28px">{{
            $t("account.notRecovered")
          }}</span>
        </div>
        <!-- <span class="contentdelete">{{$t('alarm.delete_alarm')}}</span> -->
        <div class="deletfotter" style="text-align: right; margin-top: 28px">
          <button
            class="btn btn-dark"
            style="margin-right: 10px"
            @click="configdelete"
          >
            {{ $t("alarm.Confirm") }}
          </button>
          <el-button class="btn btn-light" @click="closeDialog">
            {{ $t("alarm.Cancel") }}
          </el-button>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警结果提示(成功) -->
    <!-- v-if="delAlarmSucVisible" -->
    <deletesalarm-dialog
      :title="$t('project.delResults')"
      :visible.sync="delAlarmSucVisible"
      :class="{
        showDialog: delAlarmSucVisible,
        hideDialog: !delAlarmSucVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t("project.delSuc") }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button
              type="button"
              class="btn btn-dark"
              @click="delAlarmSucVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警结果提示(失败) -->
    <!-- v-if="delAlarmFailVisible" -->
    <deletesalarm-dialog
      :title="$t('project.delResults')"
      :visible.sync="delAlarmFailVisible"
      :class="{
        showDialog: delAlarmFailVisible,
        hideDialog: !delAlarmFailVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ alarmTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button
              type="button"
              class="btn btn-dark"
              @click="delAlarmFailVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 导出 -->
    <deletesalarm-dialog
      :title="$t('report.Export_alarm')"
      :visible.sync="exportDialog"
      :class="{ showDialog: exportDialog, hideDialog: !exportDialog }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox searchDialog">
          <!-- PN/SN -->
          <span class="search-label dot">PN</span>
          <el-input v-model="dialogSearch.search" placeholder="PN" />
          <span class="search-label">{{ $t("alarm.Alarm_Type") }}</span>
          <el-select
            v-model="dialogSearch.level"
            :placeholder="$t('header.pleaseSelect')"
            size="small"
            clearable
            popper-class="select-search-recharge"
            class="selectClearNew"
          >
            <el-option
              v-for="item in level"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span class="select-label">{{ item.label }}</span>
            </el-option>
          </el-select>
          <span class="search-label">{{ $t("alarm.Alarm_Status") }}</span>
          <el-select
            v-model="dialogSearch.handle"
            size="small"
            clearable
            popper-class="select-search-recharge"
            class="selectClearNew"
          >
            <el-option
              v-for="item in handle"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span class="select-label">{{ item.label }}</span>
            </el-option>
          </el-select>
          <span class="search-label">{{ $t("actionLog.date") }}</span>
          <el-date-picker
            :editable="false"
            clearable
            v-model="dialogDateValue"
            type="daterange"
            align="left"
            :range-separator="$t('report.to')"
            ref="dateRangePicker"
            :default-value="new Date().setMonth(new Date().getMonth() - 1)"
            :picker-options="pickerOptions"
            :start-placeholder="$t('report.start_date')"
            @blur="handleClickShow()"
            :end-placeholder="$t('report.End_date')"
            popper-class="select-date1"
          >
          </el-date-picker>
        </div>
        <!-- 确定 -->
        <div class="showoperate">
          <div class="deletfotter" style="text-align: right; margin-top: 28px">
            <el-button
              class="btn btn-light"
              style="margin-right: 10px"
              @click="closeExportDialog"
            >
              {{ $t("alarm.Cancel") }}
            </el-button>
            <el-button
              class="btn btn-dark"
              @click="confirmClick"
              :loading="confirmLoading"
            >
              {{ $t("alarm.Confirm") }}
            </el-button>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>

    <deletesalarm-dialog
      :title="$t('report.Export_alarm')"
      :visible.sync="exportListDialog"
      :class="{ showDialog: exportListDialog, hideDialog: !exportListDialog }"
      width="1200px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox" style="height: 750px">
          <el-table
            :data="exportList"
            border
            stripe
            height="500px"
            :row-style="{ height: 0 }"
            :cell-style="{ padding: 0 }"
            :header-cell-style="{
              background: 'rgb(65, 80, 90)',
              color: '#ffffff',
            }"
            element-loading-spinner="el-icon-loading"
            class="tablemain tableloding"
            :empty-text="$t('account.nodata')"
            :cell-class-name="addClass"
          >
            <el-table-column
              prop="filename"
              min-width="150px;"
              :label="$t('alarmNew.fileName')"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="status"
              :label="$t('alarmNew.fileStatus')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">{{
                  $t("alarmNew.can")
                }}</span>
                <span v-else>{{ $t("alarmNew.no") }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="size"
              :label="$t('alarmNew.fileSize')"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="gts"
              min-width="85px;"
              :label="$t('account.createTime')"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="progress"
              :label="$t('alarmNew.progress')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ scope.row.progress + "%" }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('alarm.Operation')"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="operation"
                  :title="$t('firmware.downloadFirmware')"
                  @click="exportDownLoad(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  <i class="el-icon-download"></i>
                </el-button>
                <el-button
                  type="text"
                  class="operation"
                  :title="$t('device.refresh')"
                  @click="queryExportList()"
                  v-else
                >
                  <i class="iconfont icon-refresh"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="tablebottom">
            <!-- 批量占位 -->
            <span class="" style="margin-left: 16px"></span>
            <!-- 分页 -->
            <el-pagination
              class="pagination"
              background
              @size-change="queryExportList(true)"
              @current-change="() => queryExportList()"
              :current-page.sync="dialogPagination.currentPage"
              :page-sizes="[10, 15, 20, 30, 50]"
              :page-size.sync="dialogPagination.pagesize"
              layout="slot, sizes, total, pager, prev, next, jumper"
              :total="dialogPagination.total"
              popper-class="select-page"
            >
              <span style="color: #ffffff; padding-left: 15px"
                >{{ $t("device.pageSize") }} :</span
              >
            </el-pagination>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
  </div>
</template>
<script>
import deletesalarmDialog from "@/components/dialognew";
import { mapGetters } from "vuex";
// 解决'_t' of null报错
import { i18n } from "@/i18n";
export default {
  components: {
    deletesalarmDialog, //删除弹框
  },
  data() {
    const end = new Date(); // 当前日期
    const start = new Date();
    start.setTime(end.getTime() - 30 * 24 * 60 * 60 * 1000); // 减去30天
    end.setHours(0, 0, 0, 0); // 清除时间部分
    return {
      exportReportMonthLoad: false,
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo: sessionStorage.getItem("disPermissionsLogo")
        ? JSON.parse(sessionStorage.getItem("disPermissionsLogo"))
        : false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")
        ? JSON.parse(sessionStorage.getItem("buttonArr"))
        : [],
      //表格字段数据判断
      fieldUndefined: undefined,
      // 操作返回提示
      alarmTipMsg: "",
      // 删除告警成功提示
      delAlarmSucVisible: false,
      // 删除告警失败提示
      delAlarmFailVisible: false,
      isUnfold: true,
      activeTab: "device",
      tabs: [
        {
          id: "device",
          label: this.$t("alarm.Alarm_List"),
        },
      ],
      alarmloading: false,
      showdeletesalarmdialog: false,
      selectedAlarm: [], //批量删除
      search: {
        level: "",
        // brand: "",
        handle: "false", //默认未处理(减少后端响应时间)
        // sn: "",
        search: "",
        select: "PN",
      },
      // 设备类型
      brand: {
        0: {
          value: "0",
          label: i18n.t("device.brand0"),
        },
        1: {
          value: "1",
          label: i18n.t("device.brand1"),
        },
        2: {
          value: "2",
          label: i18n.t("device.brand2"),
        },
        3: {
          value: "3",
          label: i18n.t("device.brand3"),
        },
        // 无返回值字段处理
        10: {
          value: "10",
          label: "--",
        },
      },
      level: [
        {
          label: this.$t("alarm.warning"),
          value: "0",
          name: "warning",
        },
        {
          label: this.$t("alarm.error"),
          value: "1",
          name: "standby",
        },
        {
          label: this.$t("alarm.fault"),
          value: "2",
          name: "fault",
        },
      ],
      devcode: [
        {
          value: "512",
          label: this.$t("alarm.inverter"),
        },
        {
          value: "768",
          label: this.$t("alarm.monitor"),
        },
        {
          value: "1024",
          label: this.$t("alarm.smart_meters"),
        },
        {
          value: "1280",
          label: this.$t("alarm.combining_manifolds"),
        },
        {
          value: "1536",
          label: this.$t("alarm.Camera"),
        },
        {
          value: "1792",
          label: this.$t("alarm.Battery"),
        },
        {
          value: "2048",
          label: this.$t("alarm.Charger"),
        },
        {
          value: "2304",
          label: this.$t("alarm.storage"),
        },
        {
          value: "2560",
          label: this.$t("alarm.Prevent_arcing_island"),
        },
        {
          value: "2816",
          label: this.$t("alarm.Microinverter"),
        },
      ],
      handle: [
        {
          value: "true",
          label: this.$t("alarm.processed"),
        },
        {
          value: "false",
          label: this.$t("alarm.untreated"),
        },
      ],
      alarmlist: [],
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15,
      }, // 分页数据
      params: "",
      showSearch: false,
      datevalue: "",
      //自定义日期选择限定31天
      pickerrangeOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      checkData: {
        gts: "",
        cts: "",
        handle: {},
        level: 0,
        code: "",
        desc: "",
        brand: 0,
        sn: "",
        deviceSn: "",
        alias: "",
        devaddr: "",
        pn: "",
        usr: "",
      },
      showcheckalarmdialog: false,
      infoCopy: String,
      exportDialog: false,
      dialogSearch: {
        search: "",
        level: "",
        handle: "",
      },
      dialogDateValue: [start, end],
      pickerOptions: {
        // 禁止选择今天以后的日期
        disabledDate: (time) => {
          return time.getTime() > end.getTime();
        },
        // 当用户选择一个日期时动态设置可选范围
        onPick: ({ minDate, maxDate }) => {
          if (minDate) {
            this.minDateSelected = new Date(minDate);
            this.minDateSelected.setHours(0, 0, 0, 0);
          } else {
            this.minDateSelected = null;
          }

          // 如果只选了开始日期，重置 pickerOptions 中的限制逻辑
          if (minDate && !maxDate) {
            this.pickerOptions.disabledDate =
              this.generateDisabledDateFn(minDate);
          } else {
            // 恢复为只禁用未来日期
            this.pickerOptions.disabledDate = (time) => {
              return time.getTime() > end.getTime();
            };
          }
        },
      },
      minDateSelected: null,
      exportListDialog: false,
      exportList: [],
      dialogPagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15,
      },
      confirmLoading: false,
    };
  },
  mounted() {
    if (this.$route.query.val) {
      this.search.search = this.$route.query.val;
    }
    Object.entries(this.handle).forEach((item) => {
      if (
        this.$route.query.status &&
        item[1].label.toLowerCase() == this.$route.query.status.toLowerCase()
      ) {
        this.search.handle = item[1].value;
      }
    });
    this.getData();
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo",
    }),
  },
  watch: {
    "$route.query.val": {
      handler(val) {
        if (val) {
          this.search.search = this.$route.query.val;
          this.getData();
        }
      },
    },
    exportDialog(val) {
      if (!val) {
        this.closeExportDialog();
        this.$refs.dateRangePicker.handleClose();
        document.removeEventListener("click", this.handleDocumentClick, true);
      } else {
        document.addEventListener("click", this.handleDocumentClick, true);
      }
    },
  },
  methods: {
    handleDocumentClick(event) {
      if (!this.$refs.dateRangePicker.$el.contains(event.target)&&event.target.closest('.select-date1') == null) {
      // 手动关闭日期选择器和对话框
      this.$refs.dateRangePicker.handleClose();
      }
    },
    //复制功能
    copy(info) {
      this.infoCopy = info;
      //创建input标签
      var input = document.createElement("input");
      //将input的值设置为需要复制的内容
      input.value = this.infoCopy;
      //添加input标签
      document.body.appendChild(input);
      //选中input标签
      input.select();
      //执行复制
      document.execCommand("copy");
      //成功提示信息
      this.$message.success(this.$t("datalogger.copy"));
      //移除input标签
      document.body.removeChild(input);
    },
    // 打开搜索栏
    showSearchBtn() {
      this.search = {
        level: "",
        // brand: "",
        handle: "", //默认未处理(减少后端响应时间)
        // sn: "",
        search: "",
        select: "PN",
      };
      this.datevalue = "";
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    // 关闭搜索框
    closeSearch() {
      this.showSearch = false;
      this.search.search = "";
      this.search.handle = "false";
      this.getData(true);
    },
    //  导出告警列表
    exportReportMonth() {
      if (this.disPermissionsLogo && !this.btnList.includes("export_alarm")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.exportDialog = true;
    },
    goToArchiveHistory() {
      const prefix = this.$route.path.startsWith("/adminNew")
        ? "/adminNew"
        : "/generalNew";
      this.$router.push(`${prefix}/alarm/archiveHistory`);
    },
    // exportReportMonth() {
    //   if (this.disPermissionsLogo && !this.btnList.includes('export_alarm')) {
    //     return this.$message.warning(this.$t('account.No_permission_prompt'));
    //   }
    //   let param = {
    //     action: "exportWarnings",
    //     i18n: this.$lang.currentLang,
    //     devtype: 2304,
    //     edate: this.$tool.getBeforeDate(0),
    //     sdate: this.$tool.getBeforeDate(30),
    //   }
    //   this.exportReportMonthLoad = true
    //   this.$message.success(this.$t("report.download"));
    //   this.$request
    //     .get("exportWarnings", param)
    //     .then(res => {
    //       // 演示账号
    //       if (res.err) {
    //         if (res.err == 264) {
    //           this.$message.error(this.$t("report.no_deAlarm"));
    //         } else {
    //           this.$message.error(this.$t(`errCode.${res.err}`));
    //         }
    //         return;
    //       } else {
    //         window.location.href = this.$request.http_download_url_new(param)
    //       }
    //       this.exportReportMonthLoad = false
    //     })
    //     .then(() => {
    //       // this.$message.success(this.$t("report.download"));
    //     }).catch((err) => {
    //       this.$message.error(err);
    //       this.exportReportMonthLoad = false
    //     });
    // },
    //跳转告警设备告警列表
    enterDevice(info) {
      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then((res) => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn,
                pid: info.pid,
                tab: "alarm",
              },
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //表格设备名称修改超出隐藏省略号颜色
    addClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return "deviceName";
      }
    },
    //获取表格数据
    getData(reset) {
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // (总告警)
        ...this.search,
        // 输入框有值时，search 传「选择项_输入值」（如 PN_xxx / SN_xxx）
        // search: this.search.search
        //   ? `${this.search.select}_${this.search.search}`
        //   : "",
        search: this.search.search
          ? `PN_${this.search.search}`
          : "",
        startTime: this.datevalue ? this.$filter.formatDate(this.datevalue[0]) : "",
        endTime: this.datevalue
          ? this.$filter.formatDate(this.datevalue[1], "yyyy-MM-dd") +
            " 23:59:59"
          : "",
        mode: this.datevalue ? "strict" : "",
        // devtype: 2304,
        i18n: this.$lang.currentLang,
        pageSize: this.pagination.pagesize,
        page: this.pagination.currentPage,
      };
      // select 仅为前端 PN/SN 选择控件，不作为独立参数上送
      delete param.select;
      // if (this.search.level) param.level = this.search.level;
      // if (this.search.devcode) param.devtype = this.search.devcode;
      // if (this.search.handle) param.handle = this.search.handle;
      this.alarmloading = true;
      // this.$request.get('webQueryPlantsWarning',param,'http://api.shinemonitor.com/dis05/').then(res=>{
      this.$request.getMicroserDess("/alm/api/auth/web/usr/warnings", param).then((res) => {
        if (res.code == 0) {
          res.data.items.forEach((item) => {
            // item.level = item.level ==0?this.$t('alarm.warning'):(item.level ==1?this.$t('alarm.error'):(item.level ==2?this.$t('alarm.fault'):this.$t('alarm.offline')))
            item.handle = item.handle
              ? {
                  // label: this.$t("alarm.processed"),
                  label: i18n.t("alarm.processed"),
                  class: "processed",
                }
              : {
                  // label: this.$t("alarm.untreated"),
                  label: i18n.t("alarm.untreated"),
                  class: "untreated",
                };
            item.gts = item.gts ? this.$filter.formatDate(new Date(item.gts)) : '';
            item.usr = item.uname ? item.uname : '--';
            // 后端返回deviceSn为占位符'--'时视为无效，置空后由模板回退展示sn
            item.deviceSn = item.deviceSn && item.deviceSn !== '--' ? item.deviceSn : '';
          });
          this.alarmlist = res.data.items;
          this.pagination.total = res.data.total;
          this.exportReportMonthLoad = false;
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.alarmlist = [];
          this.pagination.total = 0;
          this.exportReportMonthLoad = true;
        }
        this.alarmloading = false;
        // this.search.sn = ''
        // this.$route.query.val=""
      });
    },
    //取消按钮
    closeDialog() {
      this.showdeletesalarmdialog = false;
    },
    closeExportDialog() {
      this.exportDialog = false;
      this.dialogSearch = {
        search: "",
        level: "",
        handle: "",
      };
      let end = new Date(); // 当前日期
      let start = new Date();
      start.setTime(end.getTime() - 30 * 24 * 60 * 60 * 1000); // 减去30天
      end.setHours(0, 0, 0, 0); // 清除时间部分
      this.dialogDateValue = [start, end];
      this.confirmLoading=false;
    },
    //勾选多项
    changeFun(val) {
      this.selectedAlarm = val; // 返回的是选中的列的数组集合
    },
    //查看按钮
    checkalarm(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("alarm_details")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.checkData = info;
      this.showcheckalarmdialog = true;
    },
    //删除按钮
    detelealarm(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("delete_alarm")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      if (!info.length) return false;
      var PNAll = [];
      info.forEach((item) => {
        PNAll.push(item.id);
      });
      // console.log(PNAll)
      this.pnbox = PNAll;
      this.showdeletesalarmdialog = true;
    },
    //确定删除告警
    configdelete() {
      this.$request
        .get("ignorePlantWarning", { id: this.pnbox.join(",") })
        .then((res) => {
          if (res.err == 0) {
            // this.$message.success(this.$t("alarm.deleted_successfully"));
            this.delAlarmSucVisible = true;
            this.showdeletesalarmdialog = false;
            this.getData();
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.alarmTipMsg = this.$t(`errCode.${res.err}`);
            this.delAlarmFailVisible = true;
          }
        });
    },
    handleAccountCommand(command) {
      switch (command) {
        case "device":
          this.activeTab = "account";
          break;
        default:
          break;
      }
    },
    folding() {
      if (this.isUnfold) {
        this.isUnfold = !this.isUnfold;
      } else {
        this.isUnfold = !this.isUnfold;
      }
    },
    // 关闭批量操作弹条
    closeBatch() {
      // this.showBatch = false;
      // 用是否选中来控制批量弹条显隐
      // this.selectedAlarm = [];
      // 手动取消勾选
      this.$refs.multipleSnTable.clearSelection();
    },
    generateDisabledDateFn(startDate) {
      const thirtyDaysBefore = new Date(startDate);
      thirtyDaysBefore.setDate(startDate.getDate() - 30);

      const thirtyDaysAfter = new Date(startDate);
      thirtyDaysAfter.setDate(startDate.getDate() + 30);

      // 最终结束时间不能超过今天
      const finalMaxDate = new Date(
        Math.min(thirtyDaysAfter.getTime(), new Date().getTime())
      );

      return (time) => {
        const timeDate = new Date(time);
        timeDate.setHours(0, 0, 0, 0);

        return timeDate < thirtyDaysBefore || timeDate > finalMaxDate;
      };
    },
    handleClickShow() {
      this.$refs.dateRangePicker.blur();
    },
    confirmClick() {
      if(!this.dialogSearch.search){
        // this.$message.warning(this.$t("upgradeManagement.please_input")+'PN/SN');
        this.$message.warning(this.$t("upgradeManagement.please_input")+'PN');
        return
      }
      this.confirmLoading = true;
      let param = {
        ...this.dialogSearch,
        sdate: this.dialogDateValue
          ? this.$filter.formatDate(this.dialogDateValue[0])
          : "",
        edate: this.dialogDateValue
          ? this.$filter.formatDate(this.dialogDateValue[1], "yyyy-MM-dd") +
            " 23:59:59"
          : "",
      };
      this.$request.get("exportWarningsAsynchronous", param).then((res) => {
        if (res.err == 0) {
          this.dialogPagination.page = 1;
          let params = {
            pagesize: this.dialogPagination.pagesize,
            page: this.dialogPagination.currentPage - 1,
            i18n: this.$lang.currentLang,
          };
          this.$request.get("queryTaskFile", params).then((result) => {
            if (result.err == 0) {
              this.exportList = result.dat.list;
              this.dialogPagination.total = res.dat.total;
              this.exportListDialog = true;
              this.closeExportDialog();
            } else {
              this.exportList = [];
              this.$message.error(this.$t(`errCode.${result.err}`));
            }
          });
          this.confirmLoading = false;
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        this.confirmLoading = false;
      });
    },
    queryExportList(reset) {
      if (reset) this.dialogPagination.currentPage = 1;
      let params = {
        pagesize: this.dialogPagination.pagesize,
        page: this.dialogPagination.currentPage - 1,
      };
      this.$request.get("queryTaskFile", params).then((result) => {
        if (result.err == 0) {
          this.exportList = result.dat.list;
          this.dialogPagination.total = result.dat.total;
          if (reset && reset == 2) {
            this.exportListDialog = true;
          }
        } else {
          this.exportList = [];
          this.$message.warning(this.$t(`errCode.${result.err}`));
        }
      });
    },
    exportDownLoad(row) {
      let param = {
        action: "downLoadFile",
        i18n: this.$lang.currentLang,
        id: row.id,
      };
      window.open(this.$request.http_download_url_new(param));
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../assets/css/mixin.less");

.alarmSNew {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  // .alarm-tip-icon {
  //   display: inline-flex;
  //   align-items: center;
  //   justify-content: center;
  //   width: 16px;
  //   height: 16px;
  //   border-radius: 50%;
  //   background: #000;
  //   cursor: pointer;
  //   margin-left: 8px;

  //   .el-icon-warning {
  //     color: #fff;
  //     font-size: 12px;
  //   }
  // }

  .tablemain {
    border: none;
    background-color: rgb(34, 45, 53);

    .operation i {
      color: @primaryTextColor;
    }

    .redirect {
      color: @primaryTextColor;
    }

    /deep/.el-table--border::after,
    /deep/.el-table--group::after {
      width: 0px;
    }

    /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
      width: 16px;
      height: 16px;
      background: transparent;
      border: 1px solid rgb(180, 184, 193);
      border-radius: 0px;
    }

    /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
      top: 2px;
      left: 5px;
    }

    /deep/.el-table__header th {
      height: 48px;
    }

    /deep/.el-table__header th.is-leaf {
      border-color: rgba(198, 209, 221, 0.5);
      // border-bottom: none;
    }

    /deep/.el-table__header th > .cell {
      font-weight: normal;
      font-size: 12px;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background-color: rgb(34, 45, 53);
      color: #ffffff;
      border-color: rgba(198, 209, 221, 0.5);
    }

    /deep/.el-table__body td.el-table-column--selection {
      background-color: rgb(65, 80, 90);
      color: #ffffff;
    }

    /deep/.el-table__body .cell.el-tooltip {
      font-size: 14px;
    }

    // 右侧固定
    /deep/.el-table__fixed-right::before,
    /deep/.el-table__fixed::before {
      display: none;
    }

    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #222d35;
    }

    /deep/.el-table--border::after,
    /deep/.el-table--group::after {
      display: none;
    }

    // 关于复选框
    /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
      background: @primaryTextColor;
      border: 1px solid @primaryTextColor;
    }

    /deep/.el-checkbox
      .el-checkbox__input.is-indeterminate
      .el-checkbox__inner {
      background: @primaryTextColor;
      border: 1px solid @primaryTextColor;
    }

    // 关于头部右侧空白
    /deep/.el-table__fixed-right-patch {
      background-color: rgb(65, 80, 90);
      border-bottom: none;
    }

    /deep/th.gutter {
      background-color: rgb(65, 80, 90);
    }
  }

  .tablebottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid rgba(198, 209, 221, 0.5);

    // 分页
    .pagination {
      line-height: 48px;
      height: 48px;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-right: 16px;

      /deep/.el-pager li {
        vertical-align: middle;
      }

      /deep/.el-select .el-input {
        width: 90px;
        margin: 0px;
      }

      /deep/.el-input .el-input__inner {
        background-color: #202d35;
        color: #ffffff;
      }

      /deep/.el-input__suffix {
        right: 10px;
      }

      /deep/.el-pagination__sizes {
        margin: 0px;
        height: 48px;
        line-height: 48px;
      }

      /deep/.el-pagination__total {
        color: #fff;
        padding-left: 15px;
        border-left: 1px solid #7b8395;
        height: 48px;
        line-height: 48px;
      }

      /deep/.el-pager li:not(.disabled).active {
        // background: #15C491;
        // color: #ffffff;
        background-color: #2b3842;
        color: #15c491;
      }

      // li:not(.disabled):not(.active):hover
      /deep/.el-pager li:not(.disabled):hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pager li {
        background-color: #2b3842;
        color: #7b8395;
      }

      // 页条数下拉
      /deep/.el-select .el-input .el-input__inner {
        border: none;
        height: 48px;
        line-height: 48px;
        border-radius: 0px;
      }

      /deep/.el-select .el-input .el-input__inner:hover {
        background: @primaryColorTransparency30;
      }

      // 跳页
      /deep/.el-pagination__jump {
        color: #ffffff;
      }

      /deep/.el-pagination__editor {
        padding: 0px 6px;
      }

      /deep/.el-pagination__editor.el-input .el-input__inner {
        border: 1px solid #7b8395;
      }
    }

    // 分页前后按钮
    /deep/.el-pagination.is-background .btn-next,
    /deep/.el-pagination.is-background .btn-prev {
      background-color: #2b3842;
      color: #7b8395;
    }

    /deep/.el-pagination.is-background .btn-next:hover,
    /deep/.el-pagination.is-background .btn-prev:hover {
      background-color: @primaryColorTransparency30;
      color: rgba(255, 255, 255, 1);
    }

    /deep/.el-pagination.is-background button[disabled],
    /deep/.el-pagination.is-background button[disabled]:hover {
      background-color: #2b3842;
      color: #7b8395;
    }
  }

  .checkalarm {
    background-color: rgba(43, 63, 75);
    padding: 24px 20px;
    border-radius: 11px;
    margin-bottom: 20px;

    .alarmdetails {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
      color: rgba(255, 255, 255, 0.7);

      .ellipsis-span {
        display: inline-block;
        max-width: 250px;
        /* 根据实际宽度调整 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
      }
    }
  }

  .button-export {
    height: 48px;
    background: @primaryTextColor;
    color: rgb(34, 45, 53);
    font-size: 14px;
    border-radius: 0px;
    border: none;
    // cursor: pointer;
  }

  // margin: 20px;
  // background-color: rgb(34, 45, 53);
  // 统一按钮
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  overflow: auto;

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    // overflow: auto;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      .search-alert {
        position: absolute;
        top: 0;
        // left: 0;
        right: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 460px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {
          width: 100%;

          // PN/SN 下拉（prepend）定宽，与输入框分隔
          /deep/.el-input-group__prepend {
            width: 92px;
            padding: 0;
            background: #202d35;
            border: none;
            border-right: 1px solid #7b8395;

            .el-select {
              width: 92px;
              margin: 0;
            }

            .el-input__inner {
              width: 92px !important;
              padding: 0 24px 0 12px !important;
              text-align: left;
            }

            .el-input__suffix {
              right: 6px;
            }
          }

          // 关键词输入框自适应剩余宽度
          /deep/.el-input__inner {
            width: auto;
            padding-left: 12px !important;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #33ffb6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          // line-height: 48px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7b8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202d35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: -20px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: "X";
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-select:not(:last-child),
      /deep/.search .el-input:not(:last-child) {
        margin-right: 0px;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }
    }

    // 批量操作弹条
    .batch-alert {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 48px;
      z-index: 1;
      background: rgba(255, 231, 107, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .batch-total {
        padding-left: 16px;
        font-size: 14px;
      }

      .batch-right {
        display: flex;
        justify-content: flex-end;
      }

      .batch-hide {
        height: 48px;
        line-height: 48px;
        padding: 0px 16px;
        cursor: pointer;
        font-size: 14px;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .batch-operate {
        display: flex;
        justify-content: flex-end;

        .btn {
          color: rgba(34, 45, 53, 1);
          font-size: 14px;
          cursor: pointer;
          // display: inline-block;
          height: 48px;
          line-height: 48px;
          padding: 0px 16px;
          border-radius: 0px;
          display: flex;
          align-items: center;

          &:hover {
            background: rgba(255, 255, 255, 1);
          }
        }

        .ico-copy {
          background: url(../assets/img/general/Icon_Batch_Copy.png);
        }

        .ico-export {
          background: url(../assets/img/general/Icon_Batch_Export.png);
        }

        .ico-clear {
          background: url(../assets/img/general/Icon_Batch_Delete.png);
        }

        .ico-more {
          background: url(../assets/img/general/Icon_Batch_More.png);
        }

        .ico {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          margin-left: 8px;
        }

        // 批量更多下拉 (不可scoped)(.dropdown-more)
      }
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      .redirect {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      // 右侧固定
      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        display: none;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox
        .el-checkbox__input.is-indeterminate
        .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #222d35;
  }

  /deep/.el-range__icon {
    margin-left: 25px;
  }

  /deep/.el-date-editor--daterange {
    color: #fff;
    background-color: #2b3842;
  }

  /deep/.el-range-input {
    color: #fff;
    background-color: #222d35;
    width: 160px;
  }

  /deep/.el-range-separator {
    color: #fff;
    width: 18%;
    line-height: 48px;
  }

  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 12px;
    left: 10px;
    height: 24px;
    width: 24px;
    background: url(../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  // 日期筛选
  .alrm-date {
    /deep/.el-icon-date:before {
      content: "";
    }

    /deep/.el-input__prefix .el-input__icon:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 12px;
      right: -2px;
      height: 20px;
      width: 20px;
      background: url(../assets/img/general/Icon_Down_Border.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }
  }

  // Loading
  .el-loading-spinner .path {
    stroke: @primaryTextColor !important;
  }
}

// 下拉选中项高亮
// .select-search-recharge {
//   .el-select-dropdown__item.selected {
//     background-color: blue!important;
//     color: #ffffff;
//   }
// }
</style>
<style lang="less">
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  // font-weight: 100;
  font-family: Microsoft YaHei;
}

.select-date1.el-picker-panel {
  background-color: #222d35;
  border: none;
  padding-top: 10px;

  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222d35;
    }

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }

  .el-date-range-picker__header {
    color: #fff;
  }

  .in-range {
    background-color: #222d35;
  }

  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: @primaryTextColor;
    text-align: center;
  }

  .el-date-table td.today span {
    color: @primaryTextColor;
    font-weight: 700;
  }

  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }

  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background-color: @primaryTextColor;
    border: @primaryTextColor;
  }

  .el-date-table td.in-range {
    background-color: #222d35;
  }

  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }

  .el-date-table td {
    color: #fff;
  }

  .el-date-table td.disabled div {
    background-color: #222d35 !important;
    color: #606266 !important;
  }
}

// 筛选下拉菜单
.select-search-pro {
  width: 200px;
  background: #222d35;
  font-family: Microsoft YaHei;
  border-radius: 6px;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border: none;

  .el-select-dropdown__wrap {
    max-height: 546px;
  }

  .el-select-group__wrap:not(:last-of-type)::after {
    height: 0px;
  }

  .el-select-group__title {
    padding-left: 16px;
    font-size: 14px;
    color: #ffffff;
    border-bottom: 1px solid #424e56;
    line-height: 39px;
    margin-top: 10px;
  }

  .el-select-dropdown__item {
    padding-left: 16px;
    font-size: 14px;
    text-align: left;
    background: #222d35;
    color: #ffffff;
    font-family: Microsoft YaHei;
  }

  .el-select-group__wrap {
    padding-bottom: 0px;
  }

  // .el-select-dropdown__item.hover {
  // }
  .el-select-dropdown__item:hover {
    background: #222d35;
    color: #ffffff;
  }

  .el-select-dropdown__item.selected:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    margin-right: 5px;
    position: absolute;
    top: 6px;
    right: 12px;
  }
}

.el-table--border:after,
.el-table--group:after {
  display: none;
}

.selectClearNew {
  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

// #时间选择器 el-date-picker#
.select-date {
  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00febb;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00febb;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }

  // 月
  .el-month-table td.today .cell {
    color: #00febb;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7b8395;
  }

  .el-month-table td .cell:hover {
    color: #00febb;
  }

  // 切换年 -----
  // 年
  .el-year-table td.today .cell {
    color: #00febb;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7b8395;
  }

  .el-year-table td .cell:hover {
    color: #00febb;
  }
}

// 日期选择器增加今日快捷
.select-date {
  width: 320px !important;
  padding-top: 10px;

  // 头部
  .el-date-picker__header {
    width: 100%;
    margin: 12px 0px !important;
    padding: 0px 30px !important;
  }

  .el-picker-panel__body-wrapper {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: flex-end;

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}

.searchDialog {
  align-items: flex-start;

  .search-label {
    margin: 10px 0;
    position: relative;
  }

  .dot::before {
    content: "*";
    color: red;
    position: absolute;
    left: -10px;
  }

  .el-range-editor.el-input__inner {
    width: 100%;
  }

  .el-range-separator {
    line-height: 32px !important;
  }

  .showoperate {
    text-align: right;
  }
}
</style>
